import { render, staticRenderFns } from "./CustomerOrthoElastics.vue?vue&type=template&id=ee3c0fec"
import script from "./CustomerOrthoElastics.vue?vue&type=script&lang=js"
export * from "./CustomerOrthoElastics.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrthoElastics.vue?vue&type=style&index=0&id=ee3c0fec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports